import { render } from "./vehicles.vue?vue&type=template&id=dc1ef656&scoped=true&ts=true"
import script from "./vehicles.vue?vue&type=script&lang=ts"
export * from "./vehicles.vue?vue&type=script&lang=ts"

import "./vehicles.vue?vue&type=style&index=0&id=dc1ef656&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc1ef656"]])

export default __exports__